import RSCLogo from "../../assets/portfolio/rscompetitions.png";
import KerasjiekImage from "../../assets/portfolio/kerasjiekweb.png";
import MedievalImage from "../../assets/portfolio/medieval-td-pvp.png";
import TfAnsibleImage from "../../assets/portfolio/tf-ansible.webp";
import DockerProjects from "../../assets/portfolio/docker-projects.jpg";
import CloudSetup from "../../assets/portfolio/cloud-setup.jpg";
import SpotifyImage from "../../assets/portfolio/spotify-vibe-suggester.jpg";
import NetworkInfra from "../../assets/portfolio/network-infrastructure.jpg";
import DevOpsInfra from "../../assets/portfolio/devops-infrastructure.jpg";
import WebsiteProject1 from "../../assets/portfolio/website-project-1.jpg";
import AutomationTools from "../../assets/portfolio/automation-tools.jpg";
import UsbPicoImage from "../../assets/portfolio/usb-hardware-security-pico.jpg";
import AzureCloudImage from "../../assets/portfolio/azure-cloud-landing-zone.jpg";
import BunkSecurityImage from "../../assets/portfolio/bunk-security-ctf.jpg";
import PrioPentestImage from "../../assets/portfolio/prio-pentest-nist.jpg";
import MobelHuisSiemImage from "../../assets/portfolio/mobelhuis-siem-monitoring.jpg";

const Menu = [
  // ==================== 1. WEB & APPS ====================
  {
    id: 1,
    image: RSCLogo,
    title: "RSC Game Changers (rscompetitions.org)",
    category: "Web & Apps",
    badgeText: "Live Platform",
    badgeColor: "#10b981",
    url: "https://rscompetitions.org",
    interactiveType: "rsc",
    description: "Officiële toernooihub & broadcast layer voor EMEA Game Changers toernooien.",
    metrics: [
      { label: "Status", value: "24/7 Live" },
      { label: "Stack", value: "React 19 + Express 5" },
      { label: "Integratie", value: "Twitch API & Admin" }
    ],
    problem: "Voor het toernooicircuit ontbrak een centrale broadcast-hub om EMEA toernooien en livestreams real-time te volgen.",
    solution: "Volledig platform ontworpen en gebouwd met live wedstrijdschema's, Twitch embeds en een moderatiepaneel. Draait 24/7 stabiel in productie.",
    features: [
      { title: "React 19 & Vite Frontend", desc: "Moderne, responsive toernooihub met realtime speelschema's, uitslagen en teamprofielen.", icon: "fas fa-desktop" },
      { title: "Twitch Broadcast Integratie", desc: "Automatische embeds met live/offline streamdetectie van officiële EMEA kanalen.", icon: "fas fa-video" },
      { title: "Moderatie Dashboard (/admin)", desc: "Beveiligd portaal met token-authenticatie om scores en wedstrijden direct live te zetten.", icon: "fas fa-user-shield" },
      { title: "Security & API Rate-Limiting", desc: "Express 5 backend beveiligd tegen spam en misbruik met strikte request-validatie.", icon: "fas fa-shield-alt" }
    ],
    research: [
      { title: "Lage Netwerklatentie", desc: "Optimale streaming-integratie voor realtime wedstrijdupdates.", icon: "fas fa-bolt" },
      { title: "Security & Privacy", desc: "Veilige Bearer Token sessies en SMTP relay zonder data-lekken.", icon: "fas fa-lock" }
    ],
    tech: ["React 19", "Vite", "Node.js", "Express 5", "Twitch API", "REST API", "CSS Modules"]
  },

  {
    id: 2,
    image: KerasjiekImage,
    title: "Kerasjiek Kapperszaak & Maatwerk CMS",
    category: "Web & Apps",
    badgeText: "Live Productie",
    badgeColor: "#059669",
    url: "https://kerasjiek.nl",
    interactiveType: "kerasjiek",
    description: "Volledig platform voor een kapsalon in Veldhoven inclusief maatwerk CMS en Caddy HTTP/3 reverse proxy.",
    metrics: [
      { label: "Lighthouse", value: "99+ Score" },
      { label: "Protocol", value: "HTTP/3 & TLS 1.3" },
      { label: "Beheer", value: "Custom CMS" }
    ],
    problem: "Klant had een verouderde site, geen online afspraken en kon openingstijden niet zelfstandig bijwerken.",
    solution: "Snel responsive platform gebouwd met maatwerk CMS, 1-klik online boeken en automatische SSL via Caddy.",
    features: [
      { title: "Maatwerk CMS", desc: "Klant kan zelf tarieven, openingstijden en meldingen beheren.", icon: "fas fa-edit" },
      { title: "Online Afspraken", desc: "Conversie-geoptimaliseerde boekingsflow voor mobiel en desktop.", icon: "fas fa-calendar-check" },
      { title: "Caddy Web Server", desc: "Automatische Let's Encrypt TLS-certificaten en HTTP/3 QUIC.", icon: "fas fa-server" }
    ],
    research: [
      { title: "Core Web Vitals", desc: "Largest Contentful Paint onder de 0.9s en 0 Cumulative Layout Shift.", icon: "fas fa-tachometer-alt" },
      { title: "SEO & Toegankelijkheid", desc: "Semantische HTML5 en gestructureerde data voor lokale vindbaarheid.", icon: "fas fa-search" }
    ],
    tech: ["React", "JavaScript", "HTML5/CSS3", "Caddy Web Server", "HTTP/3", "Custom CMS", "Docker"]
  },

  {
    id: 3,
    image: SpotifyImage,
    title: "Spotify Vibe Suggester (Gemini AI)",
    category: "Web & Apps",
    badgeText: "AI & Web API",
    badgeColor: "#1db954",
    interactiveType: "spotify",
    description: "Muziek recommender die natuurlijke taalprompts analyseert via Google Gemini AI en vertaalt naar Spotify Web API parameters.",
    metrics: [
      { label: "AI Model", value: "Google Gemini" },
      { label: "API", value: "Spotify Web API" },
      { label: "Container", value: "Docker Stack" }
    ],
    problem: "Muziekluisteraars willen afspeellijsten op basis van een specifiek gevoel of situatie zonder handmatig te zoeken.",
    solution: "NLP-pipeline gebouwd met Google Gemini AI die stemmingen mapt naar Spotify audio features (tempo, valence, danceability).",
    features: [
      { title: "AI Prompt Analyse", desc: "Begrijpt context zoals 'late night debugging met rustgevende synths'.", icon: "fas fa-brain" },
      { title: "Spotify Param Mapping", desc: "Directe vertaling naar BPM, instrumentalness en valence filters.", icon: "fab fa-spotify" },
      { title: "Dockerized Backend", desc: "Microservice architectuur voor snelle API-afhandeling.", icon: "fab fa-docker" }
    ],
    research: [
      { title: "Stemmingsthermodynamica", desc: "Analyse van muzikale eigenschappen en hun invloed op concentratie.", icon: "fas fa-wave-square" },
      { title: "API Rate-Limiting", desc: "Optimalisatie van Spotify token calls en caching.", icon: "fas fa-shield-alt" }
    ],
    tech: ["Google Gemini AI", "Spotify Web API", "React", "Node.js", "Docker", "REST API"]
  },

  {
    id: 4,
    image: MedievalImage,
    title: "Medieval TD PvP – Multiplayer Arena",
    category: "Web & Apps",
    badgeText: "Realtime Game",
    badgeColor: "#8b5cf6",
    playableUrl: "https://towerdefence.bramplatier.nl/",
    interactiveType: "medieval",
    description: "Realtime online multiplayer Tower Defense game gebouwd met HTML5 Canvas, WebSockets (Socket.IO) en A* Pathfinding.",
    metrics: [
      { label: "Netwerk", value: "Socket.IO" },
      { label: "Engine", value: "60 FPS Canvas" },
      { label: "Algoritme", value: "Dynamisch A*" }
    ],
    problem: "Veel web-games hebben synchronisatie-issues tussen spelers en vertraging bij dynamische obstakels.",
    solution: "Server-authoritative game loop geïmplementeerd met realtime WebSocket synchronisatie en dynamisch herberekenende routeplanning.",
    features: [
      { title: "1v1 PvP Matchmaking", desc: "Spelers strijden live in realtime kamers (aanvaller vs verdediger).", icon: "fas fa-gamepad" },
      { title: "A* Pathfinding", desc: "Troepen berekenen direct een nieuwe kortste route bij geplaatste torens.", icon: "fas fa-route" },
      { title: "Server-Side Validatie", desc: "Schadeberekening en economie worden centraal gevalideerd.", icon: "fas fa-network-wired" }
    ],
    research: [
      { title: "Latency Compensatie", desc: "Client-side prediction en snapshot interpolatie voor soepele 60 FPS actie.", icon: "fas fa-sync" }
    ],
    tech: ["JavaScript", "HTML5 Canvas", "Node.js", "Socket.IO", "WebSockets", "A* Algorithm", "Express"]
  },

  {
    id: 5,
    image: DockerProjects,
    title: "SportPortal – Secure Authentication Design",
    category: "Web & Apps",
    badgeText: "Semester 6 • PRP",
    badgeColor: "#10b981",
    description: "Veilige webapplicatie voor sportlessen met sterke authenticatie, least privilege, audit logging en actieve monitoring voor een Blue Team.",
    metrics: [
      { label: "Architectuur", value: "Least Privilege" },
      { label: "Auth", value: "RBAC & JWT" },
      { label: "Security", value: "Red/Blue Tested" }
    ],
    problem: "Veel webapplicaties lekken data of zijn kwetsbaar voor session hijacking, brute force en privilege escalation.",
    solution: "Robuuste applicatie ontworpen met multi-tier role-based access control (RBAC), tamper-proof audit logging en defensieve headers, getest tegen Red Team aanvallen.",
    features: [
      { title: "Least Privilege RBAC", desc: "Strikte scheiding tussen studenten, trainers en beheerders.", icon: "fas fa-user-lock" },
      { title: "Audit Logging & Monitoring", desc: "Realtime loggen van security events voor Blue Team analyse.", icon: "fas fa-file-invoice" },
      { title: "Red Team Weerbaarheid", desc: "Beveiligd tegen SQLi, XSS, CSRF en credential stuffing.", icon: "fas fa-user-shield" }
    ],
    research: [
      { title: "OWASP ASVS Standard", desc: "Getoetst aan de OWASP Application Security Verification Standard.", icon: "fas fa-certificate" },
      { title: "Secure Session Management", desc: "HttpOnly cookies, CSRF-tokens en rate-limiting op login endpoints.", icon: "fas fa-key" }
    ],
    tech: ["Node.js", "Express", "JWT & Bcrypt", "RBAC", "PostgreSQL", "OWASP Top 10", "WAF"]
  },

  {
    id: 6,
    image: WebsiteProject1,
    title: "Stuvatar & Paardenstal Manege Platform",
    category: "Web & Apps",
    badgeText: "Semester 1 • Proftaak",
    badgeColor: "#eab308",
    description: "Ontwikkeling van een student-avatar platform (BMC, kostenanalyses) en een interactieve website voor een paardenstal met HTML5, CSS3 en JavaScript.",
    metrics: [
      { label: "Start HBO", value: "Semester 1" },
      { label: "Proftaak", value: "Stuvatar BMC" },
      { label: "Web Dev", value: "HTML/CSS/JS" }
    ],
    problem: "Oriëntatie op zowel de zakelijke (Business Model Canvas) als de technische kant van software- en webontwikkeling.",
    solution: "Stuvatar conceptplatform uitgewerkt met markt- en kostenanalyses, en een interactieve paardenstal manege website gebouwd met responsive layouts en formuliervalidatie.",
    features: [
      { title: "Stuvatar BMC Platform", desc: "Business Model Canvas, waardepropositie en financiële ramingen.", icon: "fas fa-briefcase" },
      { title: "Paardenstal Website", desc: "Interactieve website met JavaScript navigatie en styling.", icon: "fas fa-horse" },
      { title: "SQL & Data-analyse", desc: "Datamodellering (StartDB) en RStudio supermarkt data-analyses.", icon: "fas fa-database" }
    ],
    research: [
      { title: "Datamodellering & Queries", desc: "Relationele databases en SQL query-optimalisatie.", icon: "fas fa-table" }
    ],
    tech: ["HTML5", "CSS3", "JavaScript", "SQL", "RStudio", "Business Model Canvas"]
  },

  // ==================== 2. DEVOPS & AUTOMATISERING ====================
  {
    id: 7,
    image: TfAnsibleImage,
    title: "Ansible Automation & Proxmox RHEL Pipeline",
    category: "DevOps & Automatisering",
    badgeText: "Semester 5 • Stage Van Boxtel",
    badgeColor: "#ff4757",
    interactiveType: "ansible",
    description: "Centrale proof-of-concept deployment-architectuur met Ansible en de Proxmox API om Red Hat Enterprise Linux servers modulair en geautomatiseerd uit te rollen.",
    metrics: [
      { label: "Opdrachtgever", value: "Vanboxtel B.V." },
      { label: "Target OS", value: "RHEL 9" },
      { label: "Tools", value: "Ansible & Proxmox API" }
    ],
    problem: "Handmatige serverinstallaties kostten uren per klant en leidden tot configuratie-afwijkingen tussen applicatie- en databaseservers.",
    solution: "Volledig geautomatiseerde CI/CD provisioning pipeline gebouwd met Ansible playbooks, Proxmox API integratie, SSH hardening en firewall configuratie.",
    features: [
      { title: "Centrale Roll-out", desc: "Vanuit 1 centrale controller meerdere Proxmox hypervisors aansturen.", icon: "fas fa-network-wired" },
      { title: "Modulaire Rollen", desc: "Aparte geoptimaliseerde rollen voor applicatie- en databaseservers.", icon: "fas fa-cubes" },
      { title: "Security Baseline", desc: "Automatische CIS benchmark kernel-hardening, SELinux en accountbeheer.", icon: "fas fa-shield-alt" }
    ],
    research: [
      { title: "Onderzoeksvraag", desc: "Centrale geautomatiseerde uitrol van RHEL op Proxmox zonder vendor lock-in.", icon: "fas fa-microscope" },
      { title: "Idempotentie", desc: "Gegarandeerde voorspelbaarheid van playbook-runs zonder side-effects.", icon: "fas fa-check-double" }
    ],
    tech: ["Ansible", "Red Hat Enterprise Linux 9", "Proxmox VE API", "YAML", "Bash", "SSH Hardening", "vSphere"]
  },

  {
    id: 8,
    image: CloudSetup,
    title: "Kubernetes in Enterprise Infrastructure",
    category: "DevOps & Automatisering",
    badgeText: "Semester 7 • Onderzoek",
    badgeColor: "#3b82f6",
    interactiveType: "kubernetes",
    description: "Praktijkgericht onderzoek naar centraal monitoren, beheren, geautomatiseerd schalen (HPA) en self-healing van container-infrastructuren.",
    metrics: [
      { label: "Platform", value: "Kubernetes Cluster" },
      { label: "Autoscaling", value: "HPA (CPU/RAM)" },
      { label: "Monitoring", value: "Prometheus & Grafana" }
    ],
    problem: "Onvoorspelbare verkeerspieken veroorzaken service downtime; handmatig opschalen is te traag voor enterprise SLA's.",
    solution: "Productie-ready Kubernetes cluster ingericht met Horizontal Pod Autoscalers (HPA), liveness/readiness probes en centrale monitoring.",
    features: [
      { title: "Horizontal Pod Autoscaler", desc: "Schaalt automatisch pods op basis van CPU drempelwaarden.", icon: "fas fa-tachometer-alt" },
      { title: "Self-Healing Architecture", desc: "Herstart gecrashte pods en herstelt verkeer binnen 2 seconden.", icon: "fas fa-heartbeat" },
      { title: "Resource Limits", desc: "Strikte requests/limits per namespace om starvation te voorkomen.", icon: "fas fa-sliders-h" }
    ],
    research: [
      { title: "Capaciteitsmodellering", desc: "Testen van piekbelastingen en responstijden onder zware load.", icon: "fas fa-chart-line" },
      { title: "Multi-Cluster Beheer", desc: "Centraal deployment model voor meerdere enterprise omgevingen.", icon: "fas fa-sitemap" }
    ],
    tech: ["Kubernetes (k8s)", "Docker", "Prometheus", "Grafana", "Helm", "HPA", "Linux"]
  },

  {
    id: 9,
    image: DevOpsInfra,
    title: "Infrastructure Automation & vCenter Orchestration",
    category: "DevOps & Automatisering",
    badgeText: "Semester 3 • DevOps",
    badgeColor: "#f97316",
    description: "Geautomatiseerde uitrol en beheer van virtuele machines in VMware vCenter met PowerShell-scripts (createvm.ps1, adddomain.ps1, Active Directory onboarding).",
    metrics: [
      { label: "Platform", value: "VMware vCenter" },
      { label: "Taal", value: "PowerShell / CLI" },
      { label: "Doel", value: "Zero-Touch VM" }
    ],
    problem: "Handmatig aanmaken van virtuele machines, netwerkconfiguratie en Active Directory domeinkoppeling was tijdrovend en foutgevoelig.",
    solution: "PowerShell automatisering ontwikkeld die parameters valideert, VM templates kloont, netwerkadapters configureert en machines automatisch koppelt aan het AD domein.",
    features: [
      { title: "createvm.ps1 Engine", desc: "Automatische provisioning van CPU, RAM en vDisk in vCenter.", icon: "fas fa-terminal" },
      { title: "adddomain.ps1 Onboarding", desc: "Veilige domein-join in Active Directory met juiste OU plaatsing.", icon: "fas fa-network-wired" },
      { title: "Self-Service Workflows", desc: "Gestandaardiseerde invoerparameters voor snelle serverlevering.", icon: "fas fa-cogs" }
    ],
    research: [
      { title: "Script Optimization & Error Handling", desc: "Try-catch foutafhandeling en logging voor enterprise uitrol.", icon: "fas fa-bug" }
    ],
    tech: ["PowerShell", "VMware vCenter", "PowerCLI", "Active Directory", "Windows Server", "Automation"]
  },

  {
    id: 10,
    image: AutomationTools,
    title: "Ping Masters BV – DevOps & Staging Omgeving",
    category: "DevOps & Automatisering",
    badgeText: "Semester 3 • Infra",
    badgeColor: "#ec4899",
    description: "Realisatie van een ontwikkel-, test- en productie-infrastructuur voor een softwareteam dat een digitaal scorebordsysteem voor pingpongtafels ontwikkelde.",
    metrics: [
      { label: "Doelgroep", value: "Software Team" },
      { label: "Omgevingen", value: "DTAP Pijplijn" },
      { label: "Beheer", value: "Backend & DB" }
    ],
    problem: "Ontwikkelaars hadden geen betrouwbare test- en productie-omgeving en liepen tegen database-conflicten en onstabiele deployments aan.",
    solution: "Gestructureerde OTAP/DTAP-infrastructuur opgezet met backend-servers, MariaDB databases en geautomatiseerde release-processen.",
    features: [
      { title: "OTAP Omgevingen", desc: "Geïsoleerde ontwikkel-, staging- en live-servers.", icon: "fas fa-cubes" },
      { title: "Database Beheer", desc: "Centrale MariaDB setup met automatische back-ups en persistentie.", icon: "fas fa-database" },
      { title: "Release Workflow", desc: "Gestroomlijnde overdracht van code naar de productie-infra.", icon: "fas fa-code-branch" }
    ],
    research: [
      { title: "Omgevingsisolatie", desc: "Netwerkscheiding tussen ontwikkel- en productielagen.", icon: "fas fa-sliders-h" }
    ],
    tech: ["Linux", "Docker", "MariaDB", "Git", "CI/CD Deployments", "Bash"]
  },

  {
    id: 11,
    image: TfAnsibleImage,
    title: "Fontys Open Dag Demo & Ethical Hacking Lab",
    category: "DevOps & Automatisering",
    badgeText: "Demo & Lab",
    badgeColor: "#d97706",
    description: "Ontwikkeling en demonstratie van Ansible playbooks (deploy-vm-apache.yml) voor Fontys Open Dag bezoekers, plus een eigen ethical hacking lab voor Wi-Fi-beveiliging en hardware tests.",
    metrics: [
      { label: "Demo", value: "Live Ansible" },
      { label: "Lab", value: "Wi-Fi & Pico" },
      { label: "Doel", value: "Kennisoverdracht" }
    ],
    problem: "Complexe DevOps- en security-concepten begrijpelijk en visueel overtuigend demonstreren aan aankomende studenten en bezoekers.",
    solution: "Live Ansible demonstratie gebouwd waarbij met 1 druk op de knop een virtuele machine met Apache werd gedeployed, ondersteund door een gecontroleerd lab voor Wi-Fi en hardware-security tests.",
    features: [
      { title: "Ansible Open Dag Demo", desc: "deploy-vm-apache.yml live uitgevoerd voor bezoekers.", icon: "fas fa-play" },
      { title: "Wi-Fi Audit Lab", desc: "Testopstelling voor WPA2 handshake capture en analyse.", icon: "fas fa-wifi" },
      { title: "Hardware Testing", desc: "Geïsoleerde omgeving voor Raspberry Pi Pico payload tests.", icon: "fas fa-microchip" }
    ],
    research: [
      { title: "Educatieve Demonstraties", desc: "DevOps automatisering visualiseren voor niet-technisch publiek.", icon: "fas fa-users" }
    ],
    tech: ["Ansible", "Apache HTTP Server", "VMware / Proxmox", "Wi-Fi Security", "Raspberry Pi Pico", "Linux"]
  },

  // ==================== 3. CYBER SECURITY ====================
  {
    id: 12,
    image: MobelHuisSiemImage,
    title: "SIEM & Enterprise Monitoring (MobelHuis)",
    category: "Cyber Security",
    badgeText: "Semester 7 • MobelHuis",
    badgeColor: "#ef4444",
    interactiveType: "security",
    description: "Enterprise monitoring en security architectuur volgens TOGAF, ArchiMate en SURF-referentie, inclusief Wazuh SIEM en Checkmk capaciteitsbewaking.",
    metrics: [
      { label: "Architectuur", value: "TOGAF / ArchiMate" },
      { label: "SIEM", value: "Wazuh Agent & Server" },
      { label: "Compliance", value: "CIS Benchmark Hardened" }
    ],
    problem: "Bedrijfsinfrastructuren hebben blinde vlekken in event correlatie en missen proactieve detectie van aanvallen en capaciteitsproblemen.",
    solution: "Geïntegreerde monitoringstack opgezet met Checkmk voor servermetrieken en Wazuh SIEM voor realtime loganalyse, brute-force detectie en CIS hardening audits.",
    features: [
      { title: "Wazuh SIEM Correlatie", desc: "Realtime detectie van poortscans, mislukte logins en verdachte commando's.", icon: "fas fa-shield-alt" },
      { title: "Checkmk Infrastructure", desc: "Diepgaande CPU, RAM, disk I/O en netwerkbelasting bewaking.", icon: "fas fa-tachometer-alt" },
      { title: "CIS Hardening Audits", desc: "Periodieke geautomatiseerde audits volgens CIS Benchmark standaarden.", icon: "fas fa-clipboard-check" }
    ],
    research: [
      { title: "TOGAF & ArchiMate", desc: "Formele modelleringslagen voor bedrijfs-, applicatie- en technologielagen.", icon: "fas fa-project-diagram" },
      { title: "SURF Referentiearchitectuur", desc: "Bewezen netwerkindeling met gescheiden VLANs en redundante firewalls.", icon: "fas fa-sitemap" }
    ],
    tech: ["Wazuh SIEM", "Checkmk", "TOGAF", "ArchiMate", "CIS Benchmarks", "Suricata", "Linux Hardening"]
  },

  {
    id: 13,
    image: UsbPicoImage,
    title: "USB Attacks & Hardware Security (Raspberry Pi Pico)",
    category: "Cyber Security",
    badgeText: "Semester 4 • PRP",
    badgeColor: "#dc2626",
    description: "Onderzoek naar en nabootsen van BadUSB / Rubber Ducky-aanvallen met een Raspberry Pi Pico, inclusief defensieve GPO hardening en security awareness gids.",
    metrics: [
      { label: "Hardware", value: "RPi Pico" },
      { label: "Focus", value: "BadUSB & GPO" },
      { label: "Type", value: "PRP Onderzoek" }
    ],
    problem: "USB-poorten vormen een direct aanvalsvector voor keystroke injection en snelle malware-executie binnen bedrijfsnetwerken.",
    solution: "Labomgeving gebouwd met Active Directory, BadUSB payloads geanalyseerd met Raspberry Pi Pico, en effectieve mitigatie gerealiseerd via GPO USB-poort restriction en educatie.",
    features: [
      { title: "BadUSB Payload Emulatie", desc: "Keystroke injection payloads getest op Windows endpoints.", icon: "fas fa-microchip" },
      { title: "GPO Hardening", desc: "Groepsbeleid geconfigureerd om onbevoegde HID apparaten te blokkeren.", icon: "fas fa-shield-alt" },
      { title: "Security Awareness Gids", desc: "Educatief document voor personeel over hardware dreigingen.", icon: "fas fa-book" }
    ],
    research: [
      { title: "Impact Analyse", desc: "NIST & defensieve mitigatie voor physical endpoint security.", icon: "fas fa-search" }
    ],
    tech: ["Raspberry Pi Pico", "MicroPython", "Active Directory", "Group Policy (GPO)", "Rubber Ducky Payloads", "Windows Server"]
  },

  {
    id: 14,
    image: BunkSecurityImage,
    title: "Bunk Security Services & Hacking Week (CTF)",
    category: "Cyber Security",
    badgeText: "Semester 6 • Cyber",
    badgeColor: "#8b5cf6",
    description: "Advanced security-architectuur met dreigingsmodellering, C4-modellen, netwerksegmentatie en deelname aan de intensieve Hacking Week (Yellow Team CTF).",
    metrics: [
      { label: "Rol", value: "Yellow Team" },
      { label: "Methodiek", value: "C4 & STRIDE" },
      { label: "Focus", value: "Red & Blue Team" }
    ],
    problem: "Complexe bedrijfsnetwerken vereisen diepgaande dreigingsmodellering en realtime incident-response paraatheid.",
    solution: "Uitgebreide C4-architectuur ontworpen met zone-segmentatie, kwetsbaarheden geanalyseerd in Red/Blue team scenario's en technisch incidentrapport opgeleverd.",
    features: [
      { title: "Dreigingsmodellering", desc: "STRIDE analyse op microservices en netwerkgrenzen.", icon: "fas fa-project-diagram" },
      { title: "C4 Architectuurmodellen", desc: "Context-, container- en componentdiagrammen voor security zones.", icon: "fas fa-sitemap" },
      { title: "Hacking Week CTF", desc: "Hands-on exploitatie en verdediging in teamverband.", icon: "fas fa-flag" }
    ],
    research: [
      { title: "Mitre ATT&CK Mapping", desc: "Aanvalspatronen gemapt naar MITRE technieken voor detectie.", icon: "fas fa-clipboard-list" }
    ],
    tech: ["C4 Model", "STRIDE Threat Modeling", "Wireshark", "Burp Suite", "Nmap", "Linux Hardening"]
  },

  {
    id: 15,
    image: PrioPentestImage,
    title: "PRIO & Pentest Bedrijfsomgeving (NIST)",
    category: "Cyber Security",
    badgeText: "Semester 4 • Pentest",
    badgeColor: "#f59e0b",
    description: "Volledige pentest op een gesimuleerde infrastructuur volgens NIST-richtlijnen: server hardening, kwetsbaarheden-inventarisatie, klantinterviews en rapportage.",
    metrics: [
      { label: "Standaard", value: "NIST SP 800-115" },
      { label: "Scope", value: "Infra & Web" },
      { label: "Rapport", value: "Klantklaar" }
    ],
    problem: "Bedrijven missen vaak inzicht in hun aanvalsoppervlak en actuele configuratiefouten in hun servers en firewalls.",
    solution: "Gestructureerde black/gray-box pentest uitgevoerd, kwetsbaarheden gecategoriseerd volgens CVSS, en direct toepasbare remediatiestappen geadviseerd.",
    features: [
      { title: "NIST Pentest Methodiek", desc: "Fasering van planning, discovery, attack tot reporting.", icon: "fas fa-clipboard-check" },
      { title: "Server Hardening", desc: "Beveiliging van Linux/Windows servers tegen bekende exploits.", icon: "fas fa-shield-virus" },
      { title: "Klantadviesrapport", desc: "Risico-inschatting met prioriteitenmatrix voor het management.", icon: "fas fa-chart-line" }
    ],
    research: [
      { title: "CVSS Scoring", desc: "Objectieve prioritering van bevindingen op basis van exploitability en impact.", icon: "fas fa-calculator" }
    ],
    tech: ["Nmap", "TheHarvester", "DVWA", "Wireshark", "NIST Framework", "CVSS v3", "WAF"]
  },

  // ==================== 4. CLOUD & ENTERPRISE ====================
  {
    id: 16,
    image: AzureCloudImage,
    title: "Fonteyn Vakantieparken – Azure Cloud Migratie",
    category: "Cloud & Enterprise",
    badgeText: "Semester 2 • Cloud",
    badgeColor: "#0284c7",
    description: "Complete migratie van een verouderde vakantieparkinfrastructuur naar Microsoft Azure Cloud: Landing Zone, netwerkontwerp, Intune device management en risicoanalyses.",
    metrics: [
      { label: "Cloud", value: "Microsoft Azure" },
      { label: "Management", value: "MS Intune" },
      { label: "Aanpak", value: "ITIL Workflows" }
    ],
    problem: "Verouderde on-premise servers met single-point-of-failures, hoge onderhoudskosten en gebrek aan centraal werkplekbeheer over meerdere vakantieparken.",
    solution: "Cloud-migratieplan met Azure Landing Zone, virtual networks (VNet peering), Microsoft Intune policy beheer en ITIL incident-/changemanagement (BPMN).",
    features: [
      { title: "Azure Landing Zone", desc: "Schaalbare cloud-architectuur met gestructureerde resource groups.", icon: "fas fa-cloud" },
      { title: "Intune Device Management", desc: "Centraal beheer van endpoints en compliance policies.", icon: "fas fa-laptop" },
      { title: "ITIL & BPMN Workflows", desc: "Gestructureerde change workflows en CMDB modellen.", icon: "fas fa-sitemap" }
    ],
    research: [
      { title: "TCO & Risicoanalyse", desc: "Financiële en operationele verantwoording van on-premise vs Azure cloud.", icon: "fas fa-coins" }
    ],
    tech: ["Microsoft Azure", "Azure VNet", "Microsoft Intune", "Go (Golang)", "ITIL BPMN", "CMDB"]
  },

  {
    id: 17,
    image: DevOpsInfra,
    title: "Bonk IT voor SuitIT – Enterprise Integratie & ESB",
    category: "Cloud & Enterprise",
    badgeText: "Semester 7 • Enterprise",
    badgeColor: "#3b82f6",
    description: "Onderzoek naar enterprise-integraties en platformkeuzes (Enterprise Service Bus / ESB, cloud-native tooling en Power BI) volgens het DOT-framework.",
    metrics: [
      { label: "Klant", value: "SuitIT" },
      { label: "Methodiek", value: "DOT Framework" },
      { label: "Domein", value: "Enterprise ESB" }
    ],
    problem: "SuitIT zocht een toekomstbestendige integratiearchitectuur om uiteenlopende datasystemen en rapportages te verbinden zonder vendor lock-in.",
    solution: "Vergelijkend onderzoek uitgevoerd naar ESB-oplossingen, cloud-native integratietools en Power BI datastromen op basis van de behoeften van stakeholders.",
    features: [
      { title: "ESB Platformvergelijking", desc: "Analyse van middleware en service bus architecturen.", icon: "fas fa-random" },
      { title: "DOT-Framework Methodiek", desc: "Onderzoeksmethoden: Library, Field, Lab en Showroom.", icon: "fas fa-microscope" },
      { title: "Power BI Integratie", desc: "Datakoppelingen voor realtime management dashboards.", icon: "fas fa-chart-bar" }
    ],
    research: [
      { title: "Multi-Criteria Besluitvorming", desc: "Gewogen beslissingsmatrix voor enterprise softwarekeuze.", icon: "fas fa-balance-scale" }
    ],
    tech: ["Enterprise Architecture", "ESB Middleware", "Power BI", "Cloud-Native", "DOT Framework"]
  },

  {
    id: 18,
    image: NetworkInfra,
    title: "Proxmox VE Homelab Cluster & Thuisnetwerk",
    category: "Cloud & Enterprise",
    badgeText: "Self-Hosted Lab",
    badgeColor: "#0284c7",
    interactiveType: "homelab",
    description: "Eigen virtualisatie- en labomgeving voor het testen van hypervisors, netwerksegmentatie (VLANs, firewalls), Caddy reverse proxies en monitoring.",
    metrics: [
      { label: "Hypervisor", value: "Proxmox VE" },
      { label: "Storage", value: "ZFS Mirror Pool" },
      { label: "Netwerk", value: "VLAN Gesegmenteerd" }
    ],
    problem: "Noodzaak voor een veilige, geïsoleerde 24/7 testomgeving om enterprise technieken hands-on te valideren zonder risico voor productiediensten.",
    solution: "Proxmox cluster opgezet met dedicated VLANs (Management, DMZ, Services, IoT), reverse proxies met Caddy SSL en geautomatiseerde back-ups.",
    features: [
      { title: "VLAN Netwerksegmentatie", desc: "Strikte firewallregels tussen openbare en interne netwerklagen.", icon: "fas fa-network-wired" },
      { title: "LXC Microservices", desc: "Lichtgewicht Linux containers voor DNS (Pi-hole), Reverse Proxy en Docker.", icon: "fas fa-box" },
      { title: "ZFS Persistent Storage", desc: "Snelle mirrored snapshots voor data-integriteit en snelle rollbacks.", icon: "fas fa-database" }
    ],
    research: [
      { title: "Zero Trust Thuisnetwerk", desc: "Toepassen van enterprise Zero Trust principes in een privélab.", icon: "fas fa-user-shield" }
    ],
    tech: ["Proxmox VE", "Debian Linux", "LXC Containers", "Caddy", "ZFS", "VLANs", "pfSense / OPNsense"]
  }
];

export default Menu;
